<template>
  <div style="padding: 15px">
    <div v-html="textContent"></div>
    <!-- "textContent": "<h2>用户使用协议</h2>  <p>感谢您对影像云平台的使用与信任！为了给您提供更加优质、便捷的数字影像服务，影像云平台升级了相应的服务功能；同时根据最新监管政策的要求，我们更新了《隐私保护指引》《服务协议》，特向您说明如下：</P> 
     <p> 1、为了向您提供医疗/健康管理服务的相关功能，影像云平台会收集、使用必要信息（例如：姓名、身份证/护照号、手机号、个人健康信息等），包括但不限于向用户发出活动和服务信息等；</p> 
     <p> 2、影像云平台会采取业界先进的安全措施保护您的信息安全，将对用户资料实行保密，保护您的隐私是影像云平台的一项基本政策；</p> 
     <P> 3、未经您同意，影像云平台不会从第三方处获取、共享或向其提供您的影像或健康信息； </P> 
     <p>若您同意，请点击“同意”并开始接受我们的服务； </P> ", -->
    <van-button
      type="primary"
      block
      style="margin-top: 20px; background-color: #40a5ff; border-color: #40a5ff"
      @click="goback"
      >同意</van-button
    >
  </div>
</template>

<script>
import axios from 'axios'
import eventBus from '@/utils/eventBus.js'

export default {
  data() {
    return {
      textContent: '',
    }
  },
  mounted() {
    this.getdate()
  },
  methods: {
    getdate() {
      // 使用get请求获取到static目录下的 test.json文件的数据
      axios.get('/static/termsService.json').then((res) => {
        this.textContent = ''
        var titleTag = res.data.title.label
        var titleParagraph = res.data.title.paragraph
        this.textContent = `<${titleTag} style="text-align: center;">${titleParagraph}</${titleTag}>`
        let tempul = `
          <div>
            ${res.data.textContents
              .map((item) => {
                return `
                ${(function () {
                  if (item.titleTag && item.title) {
                    return `<${item.titleTag}>${item.title}</${item.titleTag}>`
                  } else if(item.title) {
                    return item.title
                  } else {
                    return ''
                  }
                })()}
              <p>
                ${item.paragraph
                  .map((item) => {
                    return `<p>${item}</p>`
                  })
                  .join('')}
                </p>`
              })
              .join('')}
          </div>`
        this.textContent += tempul
      })
    },
    //列表选中具体医院的点击事件
    goback() {
      eventBus.$emit('choiceHospital', true)
      //调用router回退页面
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>
::v-deep h1 {
  font: revert;
  margin: 21px 0;
}
::v-deep h2 {
  font: revert;
  margin: 19.9px 0;
}
::v-deep h3 {
  font: revert;
  margin: 18.7px 0;
}
::v-deep h4 {
  font: revert;
  margin: 20px 0;
}
::v-deep h5 {
  font: revert;
  margin: 22px 0;
}
::v-deep h6 {
  font: revert;
  margin: 24px 0;
}

::v-deep p {
  line-height: 23px;
  font-size: 14px;
  margin: 10px 0;
}
</style>